import GqlSchemaIntrospection from '@upheal/graphql/definitions/introspection.json';
import { FunctionsMap, withScalars } from 'apollo-link-scalars';
import { ApolloLink } from '@apollo/client';
import { buildClientSchema, GraphQLSchema, IntrospectionQuery } from 'graphql';
import { DateTime, Duration } from 'luxon';

let cachedSchema: GraphQLSchema | null = null;

const getSchema = (): GraphQLSchema => {
    if (!cachedSchema) {
        cachedSchema = buildClientSchema(
            GqlSchemaIntrospection as unknown as IntrospectionQuery,
        );
    }
    return cachedSchema;
};

const luxonDateTimeFunctions = {
    serialize: (parsed: unknown) => {
        if (!(parsed instanceof DateTime)) {
            throw new Error('Expected DateTime');
        }
        return parsed.toUTC().toISO();
    },
    parseValue: (raw: unknown): DateTime => {
        if (typeof raw !== 'string') {
            throw new Error('Expected string');
        }
        return DateTime.fromISO(raw).toLocal();
    },
};

const luxonDurationFunctions = {
    serialize: (parsed: unknown) => {
        if (!(parsed instanceof Duration)) {
            throw new Error('Expected Duration');
        }
        return parsed.toISO();
    },
    parseValue: (raw: unknown): Duration => {
        if (typeof raw !== 'string') {
            throw new Error('Expected string');
        }
        return Duration.fromISO(raw);
    },
};

const uuidFunctions = {
    serialize: (parsed: unknown): string => {
        if (typeof parsed !== 'string') {
            throw new Error('Expected UUID to be a string');
        }
        return parsed;
    },
    parseValue: (raw: unknown): string => {
        if (typeof raw !== 'string') {
            throw new Error('Expected UUID to be a string');
        }
        return raw;
    },
};

const typesMap: FunctionsMap = {
    Date: luxonDateTimeFunctions,
    DateTime: luxonDateTimeFunctions,
    Duration: luxonDurationFunctions,
    UUID: uuidFunctions,
};

class LazyScalarsLink extends ApolloLink {
    private link: ApolloLink | null = null;

    request(operation: any, forward: any) {
        if (!this.link) {
            this.link = withScalars({
                schema: getSchema(),
                typesMap,
                removeTypenameFromInputs: true,
            });
        }
        return this.link.request(operation, forward);
    }
}

export const scalarsLink = new LazyScalarsLink();
